import { render, staticRenderFns } from "./TaxReturnActiveImmaterialSection.vue?vue&type=template&id=ac159a94&scoped=true&"
import script from "./TaxReturnActiveImmaterialSection.vue?vue&type=script&lang=js&"
export * from "./TaxReturnActiveImmaterialSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac159a94",
  null
  
)

export default component.exports